import script from "./AppView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppView.vue?vue&type=script&lang=ts&setup=true"

import "./AppView.vue?vue&type=style&index=0&id=3fe9db97&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fe9db97"]])

export default __exports__